// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"646":"fa676915","3501":"3d10ae0a","5700":"fa676915","5848":"8839278a","6674":"9a655a13","8793":"a51722d9"}[chunkId] + ".chunk.css";
};